import { OrbitControls } from "@react-three/drei";
import { useFrame, useThree } from "@react-three/fiber";
import { memo, useEffect, useRef } from "react"
import * as THREE from 'three'
import { useCanvasContext } from "./CanvasProvider";
import { createGeometryForLevel } from "./Geometry/Geometry";


// 1. عزل كائنات الحسابات الرياضية خارج المكون تماماً لمنع إعادة إنشائها 60 مرة في الثانية
const _cameraPosition = new THREE.Vector3();
const _objectPosition = new THREE.Vector3();
const _frustum = new THREE.Frustum();
const _projScreenMatrix = new THREE.Matrix4();
const _raycaster = new THREE.Raycaster();
const _pointer = new THREE.Vector2();
const _rayDirection = new THREE.Vector3();






export const Scene = memo(({ ...props }: SceneProps) => {

    const { scene, camera } = useThree();
    const ref = useRef<THREE.Group | null>(null)
    const hoverObjectRef = useRef<THREE.Object3D | null | undefined>(null);
    const selectObjectRef = useRef<THREE.Object3D | null | undefined>(null);
    const orbitControls = useRef<any>(null);

 



    const {doPlay} = useCanvasContext();

    const printRef = useRef<boolean>(true);



   


    // 2. معالجة حسابية محسنة داخل useFrame (Frustum + Distance Culling)
    useFrame(({ camera , clock }) => {
        if (!ref.current) return;



        camera.updateMatrixWorld();
        _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        _frustum.setFromProjectionMatrix(_projScreenMatrix);
        camera.getWorldPosition(_cameraPosition);



       


        const checkVisibility = (object: THREE.Object3D) => {

           
            
            object.getWorldPosition(_objectPosition);       
            if (object instanceof THREE.Mesh) {
                if (object.geometry) {
                    const distance = _cameraPosition.distanceTo(_objectPosition);
                    if (!object.geometry.boundingBox) {
                        object.geometry.computeBoundingBox();
                    }

                    const localSize = new THREE.Vector3();
                    object.geometry.boundingBox.getSize(localSize);
                    const maxLocalDimension = Math.max(
                        localSize.x * object.scale.x, 
                        localSize.y * object.scale.y, 
                        localSize.z * object.scale.z
                    );

                    let maxSiblingSize = maxLocalDimension;

                    let maxParentDimension = maxLocalDimension; 
                    
                   if (object.parent) {
                        if (!object.parent.userData.maxSiblingSize) {
                            let maxChildDim = maxLocalDimension;
                            object.parent.children.forEach((sibling) => {
                                if (sibling instanceof THREE.Mesh && sibling.geometry) {
                                    if (!sibling.geometry.boundingBox) {
                                        sibling.geometry.computeBoundingBox();
                                    }
                                    const sibSize = new THREE.Vector3();
                                    sibling.geometry.boundingBox.getSize(sibSize);
                                    const sibMax = Math.max(
                                        sibSize.x * sibling.scale.x, 
                                        sibSize.y * sibling.scale.y, 
                                        sibSize.z * sibling.scale.z
                                    );
                                    if (sibMax > maxChildDim) {
                                        maxChildDim = sibMax;
                                    }
                                }
                            });
                            object.parent.userData.maxSiblingSize = maxChildDim;
                        }
                        maxSiblingSize = object.parent.userData.maxSiblingSize;
                    }

                 
                    const combinedSize = (maxParentDimension * 0.6 ) + (maxLocalDimension * 0.4);
                    const sizeFactor = Math.max(combinedSize, 0.5); 

                    let adjustedDistance = distance / sizeFactor;

                    let tempLevel = Math.ceil(adjustedDistance / 4);

                   const sizeRatio = maxLocalDimension / maxSiblingSize;


                    let isVisible = true;

          
                    if (tempLevel>16) {
                        object.visible = false;
                        return; 
                    }
                
                    if (!object.geometry.boundingSphere) object.geometry.computeBoundingSphere();
                    
                    isVisible = _frustum.intersectsObject(object);
                
                    let targetGeometry; 

                    if (isVisible && props.enableLOD ) {

                        
                        if (sizeRatio < 0.05 && tempLevel > 10) {
                            object.visible = false;
                            return;
                        }

                    
                   

                        if (tempLevel > 10) {
                            if (object.userData.level !== tempLevel) {
                                targetGeometry = createGeometryForLevel("box", {
                                    width: maxParentDimension,
                                    height: maxParentDimension,
                                    depth: maxParentDimension
                                }, 1);
                                object.userData.level = tempLevel;
                            }
                        }else if(object.userData.level!==tempLevel  ){
                            
                            targetGeometry = createGeometryForLevel(object?.userData?.type,object?.userData?.params,tempLevel);
                            object.userData.level = tempLevel;
                        }
                        
                      
                        if(targetGeometry && object?.geometry ){
                            object.geometry = targetGeometry;
                            object.updateMatrix();
                        }                     
                    }
                    
                    object.visible = isVisible;


                    
                } else {
                    object.visible = true;
                }
                
            }


            if (object.children && object.children.length > 0) {
                object.children.forEach((childChild) => {
                    if (!object.visible) {
                        childChild.visible = false;
                    } else {
                        checkVisibility(childChild);
                    }
                });
            }
        };

        
        ref.current.children.forEach((child) => {
            checkVisibility(child);
        });
   
    });
    
    




    useEffect(() => {
        const tCamera = camera as THREE.PerspectiveCamera

        if (tCamera) {
            props?.onLoad?.({ scene, camera: tCamera, scene_group: ref.current, orbitControls: orbitControls.current });
        }

    }, [camera]);

    // 3. تحسين دالة البحث عن المجسم الأب التكرارية
    const getMesh = (object: THREE.Object3D | null): THREE.Object3D | null => {
        if (!object) return null;
        if (object.name) return object;
        if (object.parent) return getMesh(object.parent);
        return null;
    };



    // const raycaster = new THREE.Raycaster();
    // const pointer = new THREE.Vector2();


    const handleClick = () => {



        hoverObjectRef.current && props?.onSelect?.(hoverObjectRef.current)
        // selectObjectRef.current=hoverObjectRef.current;
    }

   const handleMove = (event: MouseEvent) => {

       if (!ref.current) return;
       if(!props.isActiveSelect)return ; 

        // 4. الحساب الدقيق لإحداثيات الماوس بناءً على أبعاد الـ Canvas الفعلية وليس الـ Window بالكامل
        _pointer.x = (event.clientX / window.innerWidth) * 2 - 1;
        _pointer.y = -((event.clientY / window.innerHeight) * 2 - 1);

        _raycaster.setFromCamera(_pointer, camera);

        // نقوم بعمل فحص التقاطعات (Raycasting)

        const intersects = _raycaster.intersectObject(ref.current, true);



        if (intersects[0]) {
            const currentObject = getMesh(intersects[0].object);

            if (currentObject) {
                if (hoverObjectRef.current && hoverObjectRef.current.id !== currentObject.id) {
                    if (!selectObjectRef.current && hoverObjectRef.current.children.length > 1) {
                        hoverObjectRef.current.children = [hoverObjectRef.current.children[0]];
                    }
                }

                hoverObjectRef.current = currentObject;
                document.body.style.cursor = 'pointer';
            }
        } else {
            if (hoverObjectRef.current && !selectObjectRef.current) {
                if (hoverObjectRef.current.children.length > 1) {
                    hoverObjectRef.current.children = [hoverObjectRef.current.children[0]];
                }
            }
            hoverObjectRef.current = null;
            document.body.style.cursor = '';
        }
    };

    useEffect(() => {
        window.removeEventListener("mousemove", handleMove)
        window.removeEventListener("dblclick", handleClick)

        window.addEventListener("dblclick", handleClick)
        window.addEventListener("mousemove", handleMove)
        return () => {
            window.removeEventListener("mousemove", handleMove)
            window.removeEventListener("dblclick", handleClick)
        };
    }, [scene, camera, props.isActiveSelect]);

    return <>

        {!doPlay&&<OrbitControls makeDefault ref={orbitControls} rotateSpeed={1} minPolarAngle={0} maxPolarAngle={Math.PI / 2 - 0.01} zoomSpeed={0.5} enableDamping dampingFactor={0.05} />}

        <group name="scene-group" ref={ref} >
            {props.children}
        </group>


    </>


});

Scene.displayName = "Scene";